export class BaseRequestModel {
    constructor(obj) {
        this.AccessKey = obj.AccessKey;
        this.RequestKey = obj.RequestKey;
    }
}